module.exports = __webpack_public_path__ + "static/img/qualifications_row_5.e59fef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_company/qualifications/qualifications_row_5.png
// module id = /vUH
// module chunks = 1